
export const handleObjCleared = ({ e, canvas, fromMap }) => {
  // fromMap({ type: 'object cleared', value: e.target })
}

export const handleObjMoving = ({ e, debug, canvas, interaction }) => {
  // if(debug) console.log('object:moving,', e);
  interaction.objMoved = true;
  let obj = e.target;

  // check if we are moving one or multiple
  if(obj.piece && obj.eamsLine) {
    let left = Math.round(obj.left);
    let top  = Math.round(obj.top);
    moveLine(canvas, obj, left, top);
  } else if(obj._objects) {
    for (const item of obj._objects) {
      if(item.piece && item.eamsLine) {
        let left = Math.round(item.left + obj.left);
        let top  = Math.round(item.top + obj.top);
        moveLine(canvas, item, left, top);
      }
    }
  }
}

const moveLine = (canvas, obj, left, top) => {
  let coords = [...obj.eamsLine.points];

  if(obj.piece === 'locator') {
    coords[0] = { x: left, y: top };
  } else if(obj.piece === 'label') {
    let idx = obj.eamsLine.points.length-1;
    coords[idx] = { x: left, y: top };
  }

  // update points to immediately show on map & setCoords to
  // ensure they don't disappear on zoom - yes you need both!
  obj.eamsLine.points = coords;
  obj.eamsLine.setCoords(coords);
}

export const handleObjRotating = ({ e, debug, interaction }) => {
  // if(debug) console.log('object:moving,', e);
  interaction.bkgdLocked = true;
}

export const handleObjModified = ({ e, debug, interaction, toParent }) => {
  if(debug) console.log('object:modified,', e.action);
  let obj = e.target;

  if(e.action === 'drag') {
    let movedArr = [];
    if('appId' in obj) {
      // single item
      movedArr.push({
        id: obj.id,
        appId: obj.appId,
        phaseId: obj.phaseId,
        left: Math.round(obj.left),
        top: Math.round(obj.top),
        piece: obj.piece
      });

    } else {
      // multiple items, note that we calculate the offset here (different from above)
      for (const item of obj._objects) {
        if('appId' in item) {
          movedArr.push({
            id: item.id,
            appId: item.appId,
            phaseId: item.phaseId,
            left: Math.round(item.left + obj.left),
            top: Math.round(item.top + obj.top),
            piece: item.piece
          });
        }
      }
    }

    // then send to parent
    if(toParent) toParent({ type: 'plots moved', value: movedArr });
  }
}
